import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const FOOTER_NAV_LINKS = [
  { label: "Início", to: "/" },
  { label: "Serviços", to: "/servicos" },
  { label: "Sobre", to: "/sobre" },
  { label: "Contato", to: "/contato" },
];

const CONTACT_INFO = {
  email: "contato@eniatocontabilidade.com.br",
  phone: "+55 (11) 4210-7887",
  location: "R. Dr. Albuquerque Lins, 537 - Conj 121/122 - Santa Cecilia, São Paulo - SP, 01230-000",
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <span className="footer__brand-line" aria-hidden="true" />
          <h2 className="footer__brand-title">Eniato Contabilidade</h2>
          <p className="footer__brand-text">
            Gestão contábil, fiscal e legal com precisão técnica e atendimento
            consultivo.
          </p>
        </div>

        <div className="footer__info">
          <nav className="footer__nav" aria-label="Navegação do rodapé">
            <ul className="footer__nav-list">
              {FOOTER_NAV_LINKS.map((link) => (
                <li key={link.label} className="footer__nav-item">
                  <Link to={link.to} className="footer__nav-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="footer__contact">
            <span className="footer__contact-label">Atendimento</span>
            <a href={`mailto:${CONTACT_INFO.email}`} className="footer__contact-item">
              {CONTACT_INFO.email}
            </a>
            <a
              href={`tel:${CONTACT_INFO.phone.replace(/[^+\d]/g, "")}`}
              className="footer__contact-item"
            >
              {CONTACT_INFO.phone}
            </a>
            <span className="footer__contact-item">{CONTACT_INFO.location}</span>
          </div>
        </div>
      </div>

      <hr className="footer__divider" />

      <div className="footer__bottom">
        <p className="footer__copy">
          © {currentYear} Eniato Contabilidade - 
          Desenvolvido por <a className="sepoltech" href="https://sepoltech.com.br" target="_blank" rel="nofollow">sepolTECH</a>
        </p>
        <span className="footer__badge">Conformidade e governança</span>
      </div>
    </footer>
  );
}
